




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { AddressData } from '@/models/location';
import { VueMultiselectOptions } from '@/models/select-dropdown';
import SelectDropdownField, {
  SelectDropdownFieldVariant
} from '@/componentsV2/molecules/SelectDropdownField/SelectDropdownField.vue';
import SignUpService from '@/api/SingupService';
import SelectDropDownFieldUtils from '@/utils/selectDropdownFieldUtils';

@Component({
  components: {
    SelectDropdownField
  }
})
export default class AddressFieldDropdown extends Vue {
  @Prop({ default: false }) readonly error!: boolean;
  @Prop({ default: 'address' }) readonly name!: string;
  @Prop({ default: 'multiselectAddress' }) readonly translateKey!: string;
  @Prop({ default: () => ({ value: '', label: '' }) })
  initialValue!: VueMultiselectOptions;
  @Prop({ default: 'normal' }) variant?: SelectDropdownFieldVariant;
  @Prop() label?: string;
  @Prop({ default: '' }) helpText?: string;
  @Prop({ default: true }) showHelpIcon?: boolean;

  isLoading = false;
  adressSelected = null;
  addressOptions: Array<VueMultiselectOptions> = [];
  signUpService: SignUpService = new SignUpService();

  propertiesSelectdropdown = {
    ...SelectDropDownFieldUtils.getSelectdropdownPropertiesDefault(),
    name: this.name,
    translateKey: this.translateKey,
    useSearchIcon: true,
    maxlengthInput: '100'
  };

  get fallbackLabel() {
    return this.$t(`${this.tPrefix}.fields.address.label`);
  }

  created() {
    if (this.initialValue.value && !this.addressOptions.length) {
      this.addressOptions = [{ ...this.initialValue }];
    }
  }

  getCountryCode() {
    return this.$store.getters['internationalization/getCountrySettings']
      .countryIso2;
  }

  async searchAddress(term: string) {
    if (!term) return;

    this.isLoading = true;

    try {
      const response = await this.signUpService.getAdresses(
        term,
        this.getCountryCode()
      );

      this.addressOptions = response.data.map((country: AddressData) => ({
        value: country.fullAddress,
        label: country.fullAddress,
        additionalInformation: country
      }));
    } finally {
      this.isLoading = false;
    }
  }

  triggerSelect(selectedOption: VueMultiselectOptions) {
    this.$emit('input', selectedOption.additionalInformation);
  }

  triggerClearAll() {
    this.addressOptions = [];
    this.$emit('triggerClearValue');
  }

  get tPrefix() {
    return 'businessSignup.businessInformation';
  }
}
